import axios, { AxiosResponse } from 'axios';

import defaultHeaders, { HeaderOptions } from './default-headers';

export interface PostRequestOptions extends HeaderOptions {
  headers?: Record<string, string>;
}

/**
 * Post request
 * @param url Request URL
 * @param data Request body data
 * @param isFileUpload Flag indicating file upload
 * @param options Custom options for headers/auth
 * @returns Axios response
 */
const postRequest = async (
  url: string,
  data?: any,
  isFileUpload = false,
  options?: PostRequestOptions,
): Promise<AxiosResponse<any>> => {
  try {
    const customHeaders: Record<string, string> = isFileUpload
      ? { 'Content-Type': 'multipart/form-data' }
      : {};

    const authToken = defaultHeaders(options);
    const headers = {
      ...(authToken && authToken), // Add Authorization header if token exists
      ...customHeaders,
      ...options?.headers,
    };

    return await axios.post(url, data, { headers });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default postRequest;
